export const ROWS_PER_PAGE = [25, 10, 100] as const;
